import {
  selectProfile,
  selectUserInfo,
  selectUserPlan,
} from '@app/_store/features';
import { createFeatureSelector, createSelector } from '@ngrx/store';

/** R42. The state is a count of loads in flight; consumers still want a flag. */
const selectAppDataLoadingCount =
  createFeatureSelector<number>('appDataLoading');

export const selectAppDataLoading = createSelector(
  selectAppDataLoadingCount,
  (count) => count > 0
);

export const selectUserData = createSelector(
  selectUserInfo,
  selectProfile,
  selectUserPlan,
  (userInfo, profile, userPlan) => ({
    userInfo,
    profile,
    userPlan,
  })
);
